// extracted by mini-css-extract-plugin
export default {"columns":"Teacher_columns__RwCBk"};